export default __webpack_public_path__ + "static/media/SearchIcon.f05404aa.svg";